import { Checkbox, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommSendLoadHistory extends Layout {
    checkboxDriverDepart: Checkbox;
    panel1: Panel;
    panel2: Panel;
    panel3: Panel;
    sourceMcZmitHistory: DataSource;
    textboxAutoArrive: Textbox;
    textboxAutoDepart: Textbox;
    textboxLocalId: Textbox;
    textboxMcControlId: Textbox;
    textboxMcUnitNo: Textbox;
    textboxMovementId: Textbox;
    textboxRecordType: Textbox;
    textboxRemoteId: Textbox;
}
